// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import { Loading } from 'element-ui'
import JsPDF from 'jspdf'
export default {
  install(Vue, options) {
    Vue.prototype.getPdf = function (options) {
      var loadingInstance = Loading.service({
        fullscreen: true,
        text: '正在加载',
        background: 'rgba(0, 0, 0, 0)'
      })
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      var title = options.title
      html2Canvas(document.querySelector(options.elem), {
        allowTaint: true,
        useCORS: true,
        scale: 10,
      }).then(function (canvas) {
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 592.28 * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
        loadingInstance.close()
      }
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/htmlToPdf.js